// The map's difficulty and tags (set by the server's admins) as chips.

import type { MapInfo } from '../../shared/net/protocol';

/** Difficulty and tags of a map (what the server knows). */
export function MapMetaChips({ info }: { info: MapInfo | null }) {
  if (!info || (!info.difficulty && !info.tags.length)) return null;
  return (
    <div class="chips">
      {info.difficulty && (
        <span class="chip static" title="Difficulty (1 easy .. 5 hard)">
          Difficulty {'●'.repeat(info.difficulty)}
          {'○'.repeat(5 - info.difficulty)}
        </span>
      )}
      {info.tags.map((t) => (
        <span key={t} class="chip static chip-info">
          {t}
        </span>
      ))}
    </div>
  );
}
